import styled from '@emotion/styled';
import { Colors } from '@utex/ui-kit';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Details = styled('div')`
  color: ${Colors.text.defaultDim};
`;
